import Group from './component';
import Dashboard from './Dashboard';
import { routes as attendance } from './Attendance';
import { routes as progressTest } from './ProgressTest';
import { routes as progressReport } from './ProgressReport';
import { routes as coveredInClass } from './CoveredInClass';
import { routes as coveredInClassRAv2 } from './CoveredInClassRAv2';
import { routes as coveredInClassHFv4 } from './CoveredInClassHFv4';
import { routes as digitalPracticeRAv2 } from './DigitalPracticeRAv2';
import { routes as unitReview } from './UnitReview';
import { routes as homework } from './Homework';
import { routes as assignHomework } from './AssignHomework';
import { routes as individualDevelopmentPlan } from './IndividualDevelopmentPlan';
import { routes as writingAssignment } from './WritingAssignment';
import { routes as sessionReport } from './SessionReport';
import { routes as grammaPro } from './GrammaPro';
import { routes as midtermAndFinalExam } from './MidtermAndFinalExam';
import { routes as midtermAndFinalExamHFv4 } from './MidtermAndFinalExamHFv4';
import { routes as unitReportHFv4 } from './UnitReportHFv4';
import { routes as progressReportHFv4 } from './ProgressReportHFv4';
import { ketMockExamRoutes, ketScoreRoutes } from './KetExam';
import Privileges from 'domain/Privileges';
import { PrivilegeChecker, Config } from 'omni-common-ui';
import GroupInfoBar from './GroupInfoBar';
import is from 'is_js';

export const isIDPEnabled = () => Config.get('enableIndividualDevelopmentPlan');
export const isWritingAssignmentEnabled = () => Config.get('enableWritingAssignment');
export const isHomeworkGrammaProEnabled = () => Config.get('enableHomeworkGrammaPro');

const getErrorMessage = (props) => {
  if (props.config && is.function(props.config.icon) && props.config.icon() === 'lock') {
    return 'You have no permission to access this page.';
  }

  const NO_CONTENT_ERROR_CODE = 100001;
  const NO_SYNCED_GROUP_ERROR_CODE = 100002;
  const commonErrorMessage = 'Omni could not load this page.';
  if (! props.erroredApi || ! props.erroredApi.error) return commonErrorMessage;

  const errorResponse = props.erroredApi.error.response;
  if (! errorResponse || ! errorResponse.code) return commonErrorMessage;
  switch (errorResponse.code) {
    case NO_CONTENT_ERROR_CODE:
      return 'No content for this group.';
    case NO_SYNCED_GROUP_ERROR_CODE:
      return 'Please refresh browser to get latest information after several seconds.';
    default:
      return commonErrorMessage;
  }
};

export default ({ getState }) => ({
  path: 'group/:groupId',
  component: Group,
  appBars: {
    preSticky: {
      'group-info': {
        component: GroupInfoBar,
        order: 0,
      },
    },
  },
  indexRoute: {
    component: Dashboard,
  },
  errorPage: {
    buttonText: () => 'Back to Dashboard',
    buttonLink: ({ params: { groupId }, buildRoute }) => buildRoute(`/group/${groupId}`),
    message: getErrorMessage,
  },
  canAccess: () =>
      PrivilegeChecker.hasPrivilege(getState(), Privileges.GroupDashboard.ViewGroupDashboard),
  tab: {
    label: 'Group',
    order: 0,
  },
  breadcrumbLabels: ({ params: { groupId } }) => {
    try {
      return {
        label: getState().get('rootReducer').get('groups').get(groupId).data.number || '',
        backLinkHref: '/',
      };
    } catch (e) {
      return 'Group';
    }
  },
  childRoutes: [
    attendance,
    progressTest,
    progressReport,
    unitReportHFv4,
    coveredInClass,
    unitReview,
    homework,
    assignHomework,
    isIDPEnabled() && individualDevelopmentPlan,
    isWritingAssignmentEnabled() && writingAssignment,
    sessionReport,
    isHomeworkGrammaProEnabled() && grammaPro,
    midtermAndFinalExam,
    midtermAndFinalExamHFv4,
    coveredInClassRAv2,
    coveredInClassHFv4,
    digitalPracticeRAv2,
    progressReportHFv4,
    ketMockExamRoutes,
    ketScoreRoutes,
  ],
});



// WEBPACK FOOTER //
// ./containers/Group/routes.js